/* Voltkart shopper tools: saved items, compare, recently viewed, cart suggestions, quote prefill.
   Everything is stored in the shopper's own browser (localStorage); nothing is sent anywhere. */
(function () {
  'use strict';

  var K_WISH = 'vk_wish', K_CMP = 'vk_compare', K_REC = 'vk_recent';
  var MAX_CMP = 3, MAX_REC = 10;
  var cache = {};

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function write(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(p, w) {
    var src = p.featured_image || (p.images && p.images[0]) || '';
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 240);
  }
  function getProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { if (!r.ok) throw new Error('nf'); return r.json(); })
      .catch(function () { delete cache[handle]; return null; });
    return cache[handle];
  }
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'vk-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-in'); }, 10);
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 300); }, 2600);
  }

  /* ---------- Saved items ---------- */
  function wishCount() { return read(K_WISH).length; }

  function syncHearts() {
    var list = read(K_WISH);
    document.querySelectorAll('[data-vk-heart]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.classList.contains('vk-heart--pdp')) b.querySelector('span').textContent = on ? 'Saved' : 'Save';
    });
    var c = document.querySelector('.vk-saved-count');
    if (c) { c.textContent = list.length; c.hidden = !list.length; }
  }

  function toggleWish(handle) {
    var list = read(K_WISH), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else { list.unshift(handle); toast('Saved. Find it under the heart in the header.'); }
    write(K_WISH, list);
    syncHearts();
    renderPanel();
  }

  var panel;
  function ensurePanel() {
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'vkt-panel';
    panel.hidden = true;
    panel.innerHTML = '<div class="vkt-panel__back" data-vk-close></div><aside class="vkt-panel__box" role="dialog" aria-modal="true" aria-label="Saved items"><header><strong>Saved items</strong><button type="button" class="vkt-x" data-vk-close aria-label="Close">&times;</button></header><div class="vkt-panel__body"></div></aside>';
    document.body.appendChild(panel);
    panel.addEventListener('click', function (e) { if (e.target.closest('[data-vk-close]')) closePanel(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) closePanel(); });
    return panel;
  }
  function openPanel() { ensurePanel().hidden = false; document.documentElement.classList.add('vk-lock'); renderPanel(); }
  function closePanel() { if (panel) panel.hidden = true; document.documentElement.classList.remove('vk-lock'); }

  function renderPanel() {
    if (!panel || panel.hidden) return;
    var body = panel.querySelector('.vkt-panel__body');
    var list = read(K_WISH);
    if (!list.length) { body.innerHTML = '<p class="vk-empty">Nothing saved yet. Tap the heart on any product to keep it here.</p>'; return; }
    body.innerHTML = '<p class="vk-empty">Loading...</p>';
    Promise.all(list.map(getProduct)).then(function (items) {
      var html = '';
      items.forEach(function (p, idx) {
        if (!p) return;
        html += '<div class="vk-row"><a href="' + esc(p.url) + '"><img src="' + esc(img(p, 160)) + '" alt="" loading="lazy" width="64" height="64"></a>' +
          '<div class="vk-row__t"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><span>' + money(p.price) + (p.available ? '' : ' &middot; out of stock') + '</span></div>' +
          '<button type="button" class="vk-row__rm" data-vk-unsave="' + esc(list[idx]) + '" aria-label="Remove">&times;</button></div>';
      });
      body.innerHTML = html || '<p class="vk-empty">These products are no longer available.</p>';
    });
  }

  function addHeaderButton() {
    if (document.querySelector('.vk-saved-btn')) return;
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart || !cart.parentNode) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'header__icon vk-saved-btn link focus-inset';
    b.setAttribute('aria-label', 'Saved items');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.4-9.3C1.2 7.8 3.2 4.5 6.6 4.5c2 0 3.4 1.1 4.2 2.4h2.4c.8-1.3 2.2-2.4 4.2-2.4 3.4 0 5.4 3.3 4 6.7-1.9 4.7-9.4 9.3-9.4 9.3z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg><span class="vk-saved-count" hidden>0</span>';
    b.addEventListener('click', openPanel);
    cart.parentNode.insertBefore(b, cart);
  }

  /* ---------- Compare ---------- */
  var bar;
  function syncCompare() {
    var list = read(K_CMP);
    document.querySelectorAll('[data-vk-compare]').forEach(function (cb) {
      cb.checked = list.indexOf(cb.getAttribute('data-handle')) > -1;
    });
    if (!list.length || /^\/(cart|checkouts?)(\/|$)/.test(location.pathname)) { if (bar) bar.hidden = true; document.body.classList.remove('vk-has-cbar'); return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'vk-cbar';
      bar.innerHTML = '<span class="vk-cbar__n"></span><button type="button" class="vk-cbar__go">Compare</button><button type="button" class="vk-cbar__clear">Clear</button>';
      document.body.appendChild(bar);
      bar.querySelector('.vk-cbar__go').addEventListener('click', openCompare);
      bar.querySelector('.vk-cbar__clear').addEventListener('click', function () { write(K_CMP, []); syncCompare(); });
    }
    bar.hidden = false;
    document.body.classList.add('vk-has-cbar');
    bar.querySelector('.vk-cbar__n').textContent = list.length + ' of ' + MAX_CMP + ' selected';
    bar.querySelector('.vk-cbar__go').disabled = list.length < 2;
  }

  function onCompareChange(cb) {
    var h = cb.getAttribute('data-handle'), list = read(K_CMP), i = list.indexOf(h);
    if (cb.checked) {
      if (i < 0) {
        if (list.length >= MAX_CMP) { cb.checked = false; toast('You can compare up to ' + MAX_CMP + ' products.'); return; }
        list.push(h);
      }
    } else if (i > -1) list.splice(i, 1);
    write(K_CMP, list);
    syncCompare();
  }

  function parseSpecs(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var d = doc.querySelector('.vk-desc') || doc.body;
    var head = Array.prototype.slice.call(d.querySelectorAll('h2,h3,h4')).filter(function (h) { return /technical specification/i.test(h.textContent); })[0];
    var rows = {}, order = [];
    var n = head ? head.nextElementSibling : null, table = null;
    while (n && !/^H[1-6]$/.test(n.tagName)) {
      table = n.tagName === 'TABLE' ? n : (n.querySelector && n.querySelector('table'));
      if (table) break;
      n = n.nextElementSibling;
    }
    if (table) {
      Array.prototype.forEach.call(table.querySelectorAll('tr'), function (tr) {
        var c = tr.querySelectorAll('th,td');
        if (c.length >= 2) {
          var k = c[0].textContent.trim().replace(/\s+/g, ' '), v = c[1].textContent.trim().replace(/\s+/g, ' ');
          if (k && v && !rows[k]) { rows[k] = v; order.push(k); }
        }
      });
    }
    return { rows: rows, order: order };
  }

  var cmodal;
  function openCompare() {
    var list = read(K_CMP);
    if (list.length < 2) return;
    if (!cmodal) {
      cmodal = document.createElement('div');
      cmodal.className = 'vkt-panel vkt-panel--center';
      cmodal.hidden = true;
      cmodal.innerHTML = '<div class="vkt-panel__back" data-vk-close></div><section class="vkt-panel__box vk-cmp" role="dialog" aria-modal="true" aria-label="Compare products"><header><strong>Compare products</strong><button type="button" class="vkt-x" data-vk-close aria-label="Close">&times;</button></header><div class="vkt-panel__body"></div></section>';
      document.body.appendChild(cmodal);
      cmodal.addEventListener('click', function (e) { if (e.target.closest('[data-vk-close]')) { cmodal.hidden = true; document.documentElement.classList.remove('vk-lock'); } });
    }
    cmodal.hidden = false;
    document.documentElement.classList.add('vk-lock');
    var body = cmodal.querySelector('.vkt-panel__body');
    body.innerHTML = '<p class="vk-empty">Loading...</p>';
    Promise.all(list.map(function (h) {
      return Promise.all([getProduct(h), fetch('/products/' + encodeURIComponent(h)).then(function (r) { return r.text(); }).then(parseSpecs).catch(function () { return { rows: {}, order: [] }; })]);
    })).then(function (res) {
      var items = res.filter(function (r) { return r[0]; });
      var keys = [];
      items.forEach(function (r) { r[1].order.forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); }); });
      var t = '<div class="vk-cmp__scroll"><table class="vk-cmp__table"><thead><tr><th></th>';
      items.forEach(function (r) {
        var p = r[0];
        t += '<th><a href="' + esc(p.url) + '"><img src="' + esc(img(p, 200)) + '" alt="" width="100" height="100"></a><a class="vk-cmp__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a></th>';
      });
      t += '</tr></thead><tbody>';
      t += '<tr><th>Brand</th>' + items.map(function (r) { return '<td>' + esc(r[0].vendor) + '</td>'; }).join('') + '</tr>';
      t += '<tr><th>Price</th>' + items.map(function (r) { return '<td><strong>' + money(r[0].price) + '</strong>' + (r[0].compare_at_price > r[0].price ? ' <s>' + money(r[0].compare_at_price) + '</s>' : '') + '</td>'; }).join('') + '</tr>';
      t += '<tr><th>Availability</th>' + items.map(function (r) { return '<td>' + (r[0].available ? 'In stock' : 'Out of stock') + '</td>'; }).join('') + '</tr>';
      keys.forEach(function (k) {
        t += '<tr><th>' + esc(k) + '</th>' + items.map(function (r) { return '<td>' + esc(r[1].rows[k] || '-') + '</td>'; }).join('') + '</tr>';
      });
      t += '</tbody></table></div>';
      body.innerHTML = t;
    });
  }

  /* ---------- Recently viewed ---------- */
  function recordView() {
    var m = location.pathname.match(/^\/products\/([^\/?#]+)/);
    if (!m) return null;
    var handle = decodeURIComponent(m[1]);
    var list = read(K_REC).filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(K_REC, list.slice(0, MAX_REC));
    return handle;
  }

  function renderRecent(currentHandle) {
    var list = read(K_REC).filter(function (h) { return h !== currentHandle; }).slice(0, 6);
    if (!list.length) return;
    var slot = document.getElementById('vk-recent-slot');
    var host = slot || document.getElementById('MainContent');
    if (!host || document.querySelector('.vk-recent')) return;
    var sec = document.createElement('section');
    sec.className = 'vk-recent page-width';
    sec.innerHTML = '<h2 class="vk-recent__h">Recently viewed</h2><div class="vk-recent__row"></div>';
    host.appendChild(sec);
    Promise.all(list.map(getProduct)).then(function (items) {
      var html = '';
      items.forEach(function (p) {
        if (!p) return;
        html += '<a class="vk-rc" href="' + esc(p.url) + '"><img src="' + esc(img(p, 300)) + '" alt="" loading="lazy" width="150" height="150"><span class="vk-rc__t">' + esc(p.title) + '</span><span class="vk-rc__p">' + money(p.price) + '</span></a>';
      });
      if (!html) { sec.remove(); return; }
      sec.querySelector('.vk-recent__row').innerHTML = html;
    });
  }

  /* ---------- Product page: Save button ---------- */
  function addPdpSave(handle) {
    var title = document.querySelector('.vk-product-title');
    if (!title || document.querySelector('.vk-heart--pdp')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vk-heart--pdp';
    b.setAttribute('data-vk-heart', '');
    b.setAttribute('data-handle', handle);
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.4-9.3C1.2 7.8 3.2 4.5 6.6 4.5c2 0 3.4 1.1 4.2 2.4h2.4c.8-1.3 2.2-2.4 4.2-2.4 3.4 0 5.4 3.3 4 6.7-1.9 4.7-9.4 9.3-9.4 9.3z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg><span>Save</span>';
    var row = document.querySelector('.vk-actions');
    if (!row) {
      row = document.createElement('div');
      row.className = 'vk-actions';
      title.parentNode.insertAdjacentElement('afterend', row);
    }
    row.appendChild(b);
  }

  /* ---------- Cart page: suggestions ---------- */
  function cartSuggestions() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items.length || document.querySelector('.vk-recent--cart')) return;
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      return fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=8&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.products || []).filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 4);
          if (!ps.length) return;
          var host = document.querySelector('#main-cart-footer') || document.getElementById('MainContent');
          var sec = document.createElement('section');
          sec.className = 'vk-recent vk-recent--cart page-width';
          sec.innerHTML = '<h2 class="vk-recent__h">You may also need</h2><div class="vk-recent__row">' + ps.map(function (p) {
            var v = p.variants[0];
            return '<div class="vk-rc"><a href="' + esc(p.url) + '"><img src="' + esc(img(p, 300)) + '" alt="" loading="lazy" width="150" height="150"></a><a class="vk-rc__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="vk-rc__p">' + money(p.price) + '</span><button type="button" class="vk-rc__add" data-vk-add="' + v.id + '">Add to cart</button></div>';
          }).join('') + '</div>';
          host.parentNode.insertBefore(sec, host.nextSibling);
        });
    }).catch(function () {});
  }

  /* ---------- Wholesale page: prefill product ---------- */
  function prefillQuote() {
    if (!/^\/pages\/wholesale-enquiry/.test(location.pathname)) return;
    var p = new URLSearchParams(location.search).get('product');
    if (!p) return;
    var f = document.querySelector('[name="contact[Product/Model]"]');
    if (f && !f.value) f.value = p;
  }

  /* ---------- Judge.me badge: lives inside the white trust bar ---------- */
  function moveBadge() {
    var host = document.querySelector('.jdgm-trust-badge-mount-host');
    var inner = document.querySelector('.vk-header-v2__trustbar-inner');
    if (!host || !inner || inner.contains(host)) return;
    var sec = host.closest('.shopify-section');
    host.classList.add('vk-jm-in-bar');
    inner.appendChild(host);
    if (sec) sec.classList.add('vk-jm-moved');
  }

  /* ---------- WhatsApp button: say which product they are looking at ---------- */
  function waPrefill() {
    var a = document.querySelector('a.vk-wa');
    if (!a || a.getAttribute('data-vk-done')) return;
    var t = document.querySelector('.vk-product-title');
    var msg = t
      ? 'Hi Voltkart, I am interested in ' + t.textContent.trim() + ' (' + location.origin + location.pathname + ')'
      : 'Hi Voltkart, I need help choosing a product.';
    a.href = a.href.split('?')[0] + '?text=' + encodeURIComponent(msg);
    a.setAttribute('data-vk-done', '1');
  }

  /* ---------- Search with no results: match model numbers typed without dashes ---------- */
  function norm(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  function loadIndex() {
    try {
      var c = JSON.parse(sessionStorage.getItem('vk_idx'));
      if (c && c.t > Date.now() - 6 * 3600 * 1000) return Promise.resolve(c.items);
    } catch (e) {}
    var items = [];
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (j) {
        (j.products || []).forEach(function (p) {
          items.push({ t: p.title, u: '/products/' + p.handle, k: norm(p.title + ' ' + p.variants.map(function (v) { return v.sku; }).join(' ')) });
        });
        if ((j.products || []).length === 250 && n < 6) return page(n + 1);
      });
    }
    return page(1).then(function () {
      try { sessionStorage.setItem('vk_idx', JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
      return items;
    });
  }

  function searchFallback() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    var key = norm(q);
    if (key.length < 4 || document.querySelector('.card-wrapper') || document.querySelector('.vk-didyou')) return;
    loadIndex().then(function (items) {
      var hits = items.filter(function (i) { return i.k.indexOf(key) > -1; }).slice(0, 6);
      if (!hits.length) return;
      var box = document.createElement('div');
      box.className = 'vk-didyou page-width';
      box.innerHTML = '<p><strong>Did you mean one of these?</strong></p><ul>' + hits.map(function (h) {
        return '<li><a href="' + esc(h.u) + '">' + esc(h.t) + '</a></li>';
      }).join('') + '</ul>';
      var host = document.getElementById('MainContent');
      if (host) host.insertBefore(box, host.firstChild);
    }).catch(function () {});
  }

  /* ---------- Phones: applied-filter chips next to Filter / Sort ---------- */
  function syncChips() {
    var hdr = document.querySelector('.vk-collection-header');
    var old = document.querySelector('.vk-chips');
    if (!hdr || window.innerWidth >= 750) { if (old) old.remove(); return; }
    var src = document.querySelectorAll('.active-facets-mobile .active-facets__button');
    var seen = {}, html = '';
    Array.prototype.forEach.call(src, function (a) {
      var inner = a.querySelector('.active-facets__button-inner');
      if (!inner) return;
      var txt = inner.textContent.replace(/Remove filter/i, '').replace(/\s+/g, ' ').trim();
      if (!txt || seen[txt + a.getAttribute('href')]) return;
      seen[txt + a.getAttribute('href')] = 1;
      html += '<a href="' + esc(a.getAttribute('href')) + '">' + esc(txt) + ' &times;</a>';
    });
    var n = Object.keys(seen).length;
    var fb = document.querySelector('.vk-filter-open, #vk-filter-open');
    if (fb) {
      var c = fb.querySelector('.vk-fcount');
      if (!c) { c = document.createElement('span'); c.className = 'vk-fcount'; fb.appendChild(c); }
      c.textContent = n ? ' (' + n + ')' : '';
    }
    if (!html) { if (old) old.remove(); return; }
    if (!old) { old = document.createElement('div'); old.className = 'vk-chips'; hdr.appendChild(old); }
    if (old.innerHTML !== html) old.innerHTML = html;
  }

  /* ---------- Phones: footer link lists open on tap ---------- */
  function footerAccordion() {
    if (window.innerWidth >= 750) return;
    Array.prototype.forEach.call(document.querySelectorAll('.footer-block--menu'), function (b) {
      if (b.getAttribute('data-vkt-acc')) return;
      var h = b.querySelector('.footer-block__heading');
      if (!h) return;
      b.setAttribute('data-vkt-acc', '1');
      b.classList.add('vkt-acc');
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
      function tog() { var o = b.classList.toggle('is-open'); h.setAttribute('aria-expanded', String(o)); }
      h.addEventListener('click', tog);
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tog(); } });
    });
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-vk-heart]');
    if (h) { e.preventDefault(); e.stopPropagation(); toggleWish(h.getAttribute('data-handle')); return; }
    var u = e.target.closest('[data-vk-unsave]');
    if (u) { toggleWish(u.getAttribute('data-vk-unsave')); return; }
    var a = e.target.closest('[data-vk-add]');
    if (a) {
      a.disabled = true; a.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(a.getAttribute('data-vk-add')), quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw new Error(); location.reload(); })
        .catch(function () { a.disabled = false; a.textContent = 'Add to cart'; toast('Could not add. Please open the product.'); });
    }
  }, true);

  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-vk-compare]');
    if (cb) onCompareChange(cb);
  });

  var timer;
  function resync() { clearTimeout(timer); timer = setTimeout(function () { syncHearts(); syncCompare(); addHeaderButton(); moveBadge(); syncChips(); footerAccordion(); syncHearts(); }, 120); }

  function init() {
    addHeaderButton();
    moveBadge();
    waPrefill();
    searchFallback();
    syncChips();
    footerAccordion();
    var cur = recordView();
    if (cur) addPdpSave(cur);
    syncHearts();
    syncCompare();
    renderRecent(cur);
    cartSuggestions();
    prefillQuote();
    new MutationObserver(resync).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', resync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
